/**
 * Step Executors Registry
 *
 * Registers all built-in step executors with the workflow engine.
 */

import { registerStepExecutor } from '../workflowEngine';
import { dbStepExecutors } from './dbStep';
import { aiStepExecutors } from './aiStep';
import { fileStepExecutors } from './fileStep';
import { notifyStepExecutor } from './notifyStep';
import { httpStepExecutor } from './httpStep';
import { conditionStepExecutor } from './conditionStep';
import { transformStepExecutor } from './transformStep';
import { waitStepExecutor } from './waitStep';
import { customStepExecutor } from './customStep';
import { emailClassifierStep } from './emailClassifierStep';
import { clientMatcherStep } from './clientMatcherStep';
import { smartNotifyStep } from './smartNotifyStep';

/**
 * Register all built-in step executors
 */
export function registerAllStepExecutors(): void {
  // DB steps (query + mutation)
  for (const executor of dbStepExecutors) {
    registerStepExecutor(executor);
  }

  // AI steps (analyze + summarize + extract)
  for (const executor of aiStepExecutors) {
    registerStepExecutor(executor);
  }

  // File steps (read + write)
  for (const executor of fileStepExecutors) {
    registerStepExecutor(executor);
  }

  // Single-type executors
  registerStepExecutor(notifyStepExecutor);
  registerStepExecutor(httpStepExecutor);
  registerStepExecutor(conditionStepExecutor);
  registerStepExecutor(transformStepExecutor);
  registerStepExecutor(waitStepExecutor);
  registerStepExecutor(customStepExecutor);

  // Email workflow executors
  registerStepExecutor(emailClassifierStep);
  registerStepExecutor(clientMatcherStep);
  registerStepExecutor(smartNotifyStep);
}

// Re-export for direct access
export { dbStepExecutors } from './dbStep';
export { aiStepExecutors } from './aiStep';
export { fileStepExecutors } from './fileStep';
export { notifyStepExecutor } from './notifyStep';
export { httpStepExecutor } from './httpStep';
export { conditionStepExecutor } from './conditionStep';
export { transformStepExecutor } from './transformStep';
export { waitStepExecutor } from './waitStep';
export { customStepExecutor, registerCustomHandler, unregisterCustomHandler, getCustomHandlerNames } from './customStep';
export { emailClassifierStep } from './emailClassifierStep';
export type { EmailClassification, EmailClassificationResult } from './emailClassifierStep';
export { clientMatcherStep } from './clientMatcherStep';
export type { ClientMatchResult } from './clientMatcherStep';
export { smartNotifyStep } from './smartNotifyStep';
